import { css, cva } from '@/styled-system/css';

export const cardContainerRecipe = cva({
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // oxlint-disable-next-line constellation/no-raw-spacing-values -- `width: 168px` falls between `4000` (160px) and `5000` (200px) on the numeric sizes scale
    width: '168px',
    height: '100%',
    borderRadius: '200',
    border: '2px solid {colors.border.accent.brand.hero}',
  },
  variants: {
    isHovered: {
      true: { backgroundColor: 'bg.accent.blue.soft' },
      false: { backgroundColor: 'bg.neutral' },
    },
  },
});

export const cardAddressStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
});

export const myPropertyHeaderStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `height: 246px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
  height: '246px',
});

export const myPropertyFactsContainerStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `height: 113px` falls between `2600` (104px) and `3600` (144px) on the numeric sizes scale
  height: '113px',
  width: '100%',
});

export const myPropertyBannerStyles = css.raw({
  backgroundColor: 'bg.accent.brand.hero',
  color: 'text.onImpact.neutral',
  width: '100%',
  textAlign: 'center',
  borderRadius: '100',
});
